import React from 'react';
import PropTypes from 'prop-types';

const BPLogo = ({ logoUrl, redirectUrl, height }) => (
  <a href={redirectUrl}>
    <span>
      <img src={logoUrl} alt="GasBuddy Business Pages" height={height} style={{ margin: '0px 10px' }} />
    </span>
  </a>
);

BPLogo.defaultProps = {
  height: 40,
  redirectUrl: '',
};

BPLogo.propTypes = {
  height: PropTypes.number,
  logoUrl: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string,
};

export default BPLogo;
